'use client';

import { useGetSupabaseSession } from '@/hooks/useGetSupabaseSession';
import Stats from './Stats';
import GuestStats from './GuestStats';

const StatsPage = () => {
  const session = useGetSupabaseSession();

  if (session === undefined) {
    return <div className="container">Loading...</div>;
  }

  if (session === null) {
    return <GuestStats />;
  }

  return (
    <main className="mx-auto mb-16 w-full max-w-4xl space-y-4 px-4 lg:px-0">
      <Stats />
    </main>
  );
};

export default StatsPage;
